import React, { useEffect, useState } from 'react';
import { InputForm } from '../atoms/input';
import { icon } from '../functions/icons';
import { ImageSelectorModalCopy } from './customModals';


const PhotoOption = ({ option, onSelect }) => {
    return (
        <div className={`photo-option-quiz ${option.quiz_correct_answer && 'active'}`} onClick={onSelect} >
            <img className="photo-option-quiz-img" src={option.quiz_answer.image.url} alt={option.label} />

        </div>
    );
};


const PhotoOptions = ({ data, onSelect, updateAnswer }) => {
    const [quizQuestion, setQuizQuestion] = useState("")
    const [visibleModal, setVisibleModal] = useState(false)
    const [options, setOptions] = useState({ quiz_answers: [], quiz_question: "", quiz_answer_content: [] })

    function changeQuestionTitle(text) {
        setQuizQuestion(text)
        const completeContent = { ...options }
        completeContent.quiz_question = text
        completeContent.quiz_answer_content = completeContent.quiz_answers
        updateAnswer(completeContent)
    }
    const addAnswer = (image) => {
        const copyData = { ...options }
        const copy2 = {...options}
        console.log("Here are quiz_answers!::::", copyData?.quiz_answers)
        copyData.quiz_answers = copyData?.quiz_answers ? [...copyData.quiz_answers, { quiz_answer: image }] : [{ quiz_answer: image }]
        copyData.quiz_answer_content = copyData?.quiz_answer_content ? [...copy2.quiz_answers, { quiz_answer: image }] : [{ quiz_answer: image }]
        copyData.quiz_question = quizQuestion
        console.log("here is the data:::::",copyData)
        updateAnswer(copyData)
        setOptions(copyData)
        setVisibleModal(!visibleModal)
    }
    const handleSelect = (index) => {
        const copyComplete = { ...options }
        copyComplete.quiz_answers[index].quiz_correct_answer = !copyComplete.quiz_answers[index].quiz_correct_answer
        copyComplete.quiz_answer_content = copyComplete.quiz_answers
        copyComplete.quiz_question = quizQuestion
        updateAnswer(copyComplete)
        setOptions(copyComplete)
    }

    useEffect(() => {
        
        if (data?.quiz_question || data?.quiz_answers) {
            setOptions({ ...data })
            setQuizQuestion(data?.quiz_question)
        }
    }, [])

    return (
        <div className="photo-options-quiz">
            <InputForm
                title={"Quiz vraag:"}
                selectedValue={data?.quiz_type || 1}
                placeholder={"Voeg hier uw vraag in"}
                typeInput={(newText) => changeQuestionTitle(newText)}
                value={quizQuestion}
            />
            <div className="photo-options-quiz-grid">
                {options?.quiz_answers && options.quiz_answers.map((option, index) => (
                    <PhotoOption key={index} option={option} onSelect={() => handleSelect(index)} />
                ))}

                {options?.quiz_answers.length < 4 && <AddPhoto add={() => setVisibleModal(!visibleModal)} />}
            </div>
            <ImageSelectorModalCopy
                visible={visibleModal}
                dismiss={() => setVisibleModal(!visibleModal)}
                imageSelected={(image) => addAnswer(image)}

            />
        </div>
    );
};


const AddPhoto = ({ add }) => {
    return (
        <div onClick={add} className="add-photo-button standard-border  standard-padding small-rounded" style={{ borderColor: "var(--grey-200)" }}>

            {icon('photo')}
            <p className="standard-text" style={{ marginTop: "0.5rem" }}>Voeg foto toe</p>
        </div>
    )
}
export { PhotoOptions, PhotoOption }